module.exports = __webpack_public_path__ + "img/logo_mini.a6f26d1c.png";